import { Button, useStepperReturn } from '@ais-ui/ui-core';
import { useLocalization } from '@ais-ui/locale-management';

interface StepperFooterProps {
  onPrevious: ((event: React.MouseEvent<HTMLButtonElement>) => void) | null;
  onNext: () => void;
  stepperProps: useStepperReturn;
}

export const StepperFooter = ({
  onPrevious,
  onNext,
  stepperProps,
}: StepperFooterProps) => {
  const { messages } = useLocalization();

  return (
    <div className="flex items-center justify-end gap-2 sticky bottom-2">
      {onPrevious && (
        <Button type="button" onClick={onPrevious}>
          {messages.reportsCreateReportStepperPrevious}
        </Button>
      )}
      <Button type="button" id="reports-creation-next-step-button" onClick={onNext}>
        {stepperProps.isLastStep
          ? messages.genericSubmit
          : stepperProps.isOptionalStep
          ? messages.reportsCreateReportStepperSkip
          : messages.reportsCreateReportStepperNext}
      </Button>
    </div>
  );
};
